import React from "react";
import styled from "styled-components";
import { LabelText, TitleText } from "../../ui/Text";
import { get } from "../../utils/get";

interface IProps {
  backgroundColor?: string;
  taskCardItemData?: any;
}
export const TaskCardItem = ({ backgroundColor, taskCardItemData }: IProps) => {
  return (
    <TaskItemContainer backgroundColor={backgroundColor}>
      <TitleText>{get(taskCardItemData, "name")}</TitleText>
      <ImagesContainer>
        {get(taskCardItemData, "owners", []).map((owner) => (
          <ImageItem
            src={owner?.avatar_url || require("../../assets/images/user.png")}
            alt="owner"
          />
        ))}
      </ImagesContainer>
      <LabelText
        color="#01A8CE"
        style={{
          backgroundColor: "#EBEFFF",
          padding: "0.3em 1em",
          fontSize: "0.7em",
          textAlign: "center",
          borderRadius: 5,
          justifySelf: "left",
          margin: "0.1em 0",
        }}
      >
        {get(taskCardItemData, "status")}
      </LabelText>
    </TaskItemContainer>
  );
};
const TaskItemContainer = styled.div<{ backgroundColor?: string }>`
  display: grid;
  border: 1px solid #ebeeff;
  border-radius: 10px;
  grid-template-rows: auto auto auto auto;
  grid-row-gap: 0.3em;
  padding: 0.3em 1em;
  background-color: ${(props) => props.backgroundColor || "#fff"};
  margin-bottom: 0.5em;
  ${TitleText} {
    font-size: 0.7em;
    font-weight: bold;
  }
  ${LabelText} {
    font-size: 0.7em;
  }
`;
const ImagesContainer = styled.div`
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;
const ImageItem = styled.img`
  margin-left: -10px;
  border: 0.2em solid #fff;
  border-radius: 1em;
  width: 1.3em;
  height: 1.3em;
`;
